import React from 'react';

import {
  EditablePropertyField,
  EditPropertyFieldInputType,
  portfolioCovenantPropertyKeysToShow,
} from '../../edit/EditablePropertyField';
import { CreditAgreement, WipConfig } from 'packages/creditAgreements/ui/types';

const propertyFieldsConfig: {
  basePropertyKey: typeof portfolioCovenantPropertyKeysToShow[number];
  label: string;
  inputType?: EditPropertyFieldInputType;
  isEditDisabled?: boolean;
}[] = [
  {
    basePropertyKey: 'covenantKey',
    label: 'Key',
    isEditDisabled: true,
  },
  {
    basePropertyKey: 'name',
    label: 'Name',
  },
  {
    basePropertyKey: 'section',
    label: 'Credit Agreement Section',
  },
  {
    basePropertyKey: 'description',
    label: 'Description',
    inputType: 'textArea',
  },
];

export const PortfolioCovenantEditProperties = ({
  wipConfig,
  fullPropertyKey,
  portfolioCovenant,
}: {
  wipConfig: WipConfig;
  fullPropertyKey: string;
  portfolioCovenant: CreditAgreement.DomainEntity.PortfolioCovenantProperty;
}) => {
  return (
    <>
      {propertyFieldsConfig.map((property) => (
        <EditablePropertyField
          wipConfig={wipConfig}
          fullPropertyKey={fullPropertyKey}
          basePropertyKey={property.basePropertyKey}
          label={property.label}
          isEditDisabled={property.isEditDisabled}
          key={property.basePropertyKey}
          inputType={property.inputType}
          portfolioCovenant={portfolioCovenant}
        />
      ))}
    </>
  );
};
